import {
	NavigateOptions,
	RouteComponentProps,
	WindowLocation,
} from '@gatsbyjs/reach-router';
import { navigate } from 'gatsby';
import { requestStatus } from '../../hoc/context/api';
import { EnrollmentContextService } from '../../hoc/context/enrollment/enrollment-context';
import { Configuration } from '../../../hooks/useConfiguration';

// TODO should come from theme configuration
export const homePath = '/';
export const basePath = 'enrollment';

export interface FlowRouteProps extends RouteComponentProps {
	flow: Flow;
	path: string;
}

export interface FlowStep {
	path: string;
	component: Function;
	flow: Flow;
	condition?: Function;
}

export abstract class Flow {
	path: string;
	protected configuration: Configuration;
	protected enrollmentCtxt: EnrollmentContextService;
	protected parent: Flow | undefined;

	constructor(
		path: string,
		configuration: Configuration,
		enrollmentCtxt: EnrollmentContextService,
		parent?: Flow
	) {
		this.path = path;
		this.configuration = configuration;
		this.enrollmentCtxt = enrollmentCtxt;
		this.parent = parent;
	}

	abstract get steps(): FlowStep[];
	//TODO - params any is ok as it won't cause any type issues, to be fixed in future
	abstract next(location: WindowLocation, params?: any): void; //NOSONAR
	get uri(): string {
		return (this.parent ? this.parent.uri : '/') + this.path + '/';
	}
	protected navigate(path: string, options?: NavigateOptions<{}>) {
		navigate(this.uri + path, options);
	}
	protected onEnd(location: WindowLocation) {
		this.parent?.next(location);
	}
	restart() {
		this.enrollmentCtxt.resetInput();
		navigate(homePath);
	}
	terminate(location: WindowLocation, status: requestStatus) {
		this.parent?.terminate(location, status);
	}
}

export default Flow;
